import {API} from "@/Composables/api";

const analyzeQuestion = async (question: string, aiChat?: string, data, params = {}) => {
    return API.post(route("questions.analyze", [question, aiChat]), params, data);
};

const analyzeGroup = async (group: string, aiChat?: string, data, params = {}) => {
    return API.post(route("groups.analyze", [group, aiChat]), params, data);
};

export {analyzeQuestion, analyzeGroup};
